import { openBlock as t, createElementBlock as c, createStaticVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, o = /* @__PURE__ */ e('<g fill="currentColor" clip-path="url(#check-circle-bold-2_svg__a)"><path d="M24 12c0 6.628-5.372 12-12 12S0 18.628 0 12 5.372 0 12 0s12 5.372 12 12" opacity=".5"></path><path d="M16.836 8.364a.9.9 0 0 1 0 1.272l-6 6a.9.9 0 0 1-1.272 0l-2.4-2.4a.9.9 0 1 1 1.272-1.272l1.764 1.764 2.682-2.683 2.682-2.681a.9.9 0 0 1 1.272 0"></path></g><defs><clipPath id="check-circle-bold-2_svg__a"><path fill="currentColor" d="M0 0h24v24H0z"></path></clipPath></defs>', 2), a = [
  o
];
function r(h, i) {
  return t(), c("svg", l, [...a]);
}
const n = { render: r };
export {
  n as default,
  r as render
};
